import './App.css';
import { Route, Routes, BrowserRouter } from 'react-router-dom';
import Footer from './Components/Footer';
import Header from './Components/Header';
import Home from './Components/Home';
import Contact from './Components/Contact';
import Menu from './Components/Menu';
import About from './Components/About';

function App() {
  return (
    <BrowserRouter>
    <div className="App">
        <Header/>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/menu" element={<Menu />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        <Footer/>
      </div>
    </BrowserRouter>
  );
}

export default App;
